<i [ngClass]="[ icon_prefix_class, icon_class ]"></i>
